export const defaultQuickFilter = () => null;
